<discovery-instructions
  [data]="data"
  [mainTitle]="mainTitle"
  [instructions]="instructions"
  (previousNextInstructionEventEmitter)="instructionBackOrForwardEvent($event)"
></discovery-instructions>
